import { colorToScore } from './areaData.js';

// The area facts the listing full view shows: the RegSO's raw values (from `areaStats`) and each metric's
// neighbourhood score (1–6, from the scoring `colorCache`). Shared by kartvy and listvy.

const SCORE_PREFIX_BY_METRIC = {
    income: 'netInc_',
    unemployment: 'unemployment_',
    owned: 'apartment_',
    education: 'education_',
    apartmentPrice: 'sqm_price_apartment_',
    housePrice: 'sqm_price_house_',
};

const finiteOrNull = (value) => (Number.isFinite(value) ? value : null);
// A sqm price of -1 (or 0) means no sales data.
const priceOrNull = (value) => (Number.isFinite(value) && value > 0 ? value : null);

const regsoNamesByTopology = new WeakMap();

export const getRegsoName = (topology, regsoCode) => {
    if (!topology?.objects || !regsoCode) return '';
    let names = regsoNamesByTopology.get(topology);
    if (!names) {
        names = new Map();
        Object.values(topology.objects).forEach((object) => {
            (object?.geometries || []).forEach((geometry) => {
                const code = String(geometry?.properties?.regsokod || '').trim();
                const name = String(geometry?.properties?.regso || '').trim();
                if (code && name) names.set(code, name);
            });
        });
        regsoNamesByTopology.set(topology, names);
    }
    return names.get(String(regsoCode)) || '';
};

export const buildListingAreaInfo = ({ regsoCode, areaStats, colorCache, topology }) => {
    if (!regsoCode || !areaStats) return null;
    const apartmentSqm = priceOrNull(areaStats[`sqm_price_apartment_${regsoCode}`]);
    const houseSqm = priceOrNull(areaStats[`sqm_price_house_${regsoCode}`]);
    const netIncome = finiteOrNull(areaStats[`netInc_${regsoCode}`]);
    const unemployment = finiteOrNull(areaStats[`unemployment_${regsoCode}`]);
    const ownedShare = finiteOrNull(areaStats[`apartment_${regsoCode}`]);
    const education = finiteOrNull(areaStats[`education_${regsoCode}`]);
    if ([apartmentSqm, houseSqm, netIncome, unemployment, ownedShare, education].every((value) => value == null)) {
        return null;
    }
    const scores = {};
    Object.entries(SCORE_PREFIX_BY_METRIC).forEach(([metric, prefix]) => {
        scores[metric] = colorCache ? (colorToScore[colorCache[`${prefix}${regsoCode}`]] ?? null) : null;
    });
    return {
        name: getRegsoName(topology, regsoCode),
        apartmentSqm,
        houseSqm,
        incomeMonthlyTkr: netIncome != null ? netIncome / 12 / 1000 : null,
        unemploymentPercent: unemployment,
        ownedPercent: ownedShare != null ? ownedShare * 100 : null,
        educationPercent: education,
        scores,
    };
};
